/* import __COLOCATED_TEMPLATE__ from './linear-pie-chart.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import clsx from 'clsx';

const _normalizeHexToCode = (hex) => {
  return hex.substr(0, 1) === '#' ? hex.slice(1) : hex;
}

const CLASS_NAME = 'SH-c-linear-pie-chart';

class LinearPieChartComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  #colorValuesMapCache = createCache(() => {
    const { colors } = this.args;
    return this.args.values.reduce((accum, value, index) => {
      if (value) {
        accum[_normalizeHexToCode(colors[index])] = value;
      }

      return accum;
    }, {});
  });

  get colorValuesMap() {
    return getValue(this.#colorValuesMapCache);
  }

  #valueSumCache = createCache(() => {
    return this.args.values.reduce((sum, value) => sum + value, 0);
  });

  get valueSum() {
    return getValue(this.#valueSumCache);
  }

  #childStylesMapCache = createCache(() => {
    const { colorValuesMap, valueSum } = this;
    return Object.keys(colorValuesMap).reduce((accum, hexColor) => {
      accum[hexColor] = htmlSafe(`
        background-color: #${hexColor};
        width: ${(colorValuesMap[hexColor] / valueSum) * 100}%;
      `);
      return accum;
    }, {});
  });

  get childStylesMap() {
    return getValue(this.#childStylesMapCache);
  }
}

export default LinearPieChartComponent;
